import React from "react"
import { useSelector } from "react-redux"
import CustomTag from "components/Atoms/CustomTag"

export default function TotalOrders({ isCountFilter, count }) {
  const selectedSchedules = useSelector(state => {
    const allSelected = state?.selector?.orders?.selected
    return (allSelected && Object.keys(allSelected).length) || 0
  })

  return (
    <CustomTag large round minimal>
      {isCountFilter ? count : selectedSchedules} Selected
    </CustomTag>
  )
}
